import { UAParser } from 'ua-parser-js';

import { Device } from '../types';

export class DeviceInfoService {
  static getDeviceInfo(): Device {
    const parser = new UAParser();
    const result = parser.getResult();

    const isMobile = result.device.type === 'mobile';
    const isTablet = result.device.type === 'tablet';
    const isDesktop = !result.device.type || (!isMobile && !isTablet && !['console', 'smarttv', 'wearable', 'xr', 'embedded'].includes(result.device.type));

    return {
      client: this.getClient(result),
      cpuArchitecture: result.cpu.architecture || 'Unknown',
      deviceType: this.getDeviceType(result),
      deviceModel: result.device.model || 'Unknown',
      deviceVendor: result.device.vendor || 'Unknown',
      osName: result.os.name || 'Unknown',
      osVersion: result.os.version || 'Unknown',
      screenSize: this.getScreenSize(),
      userAgent: navigator.userAgent,
      browser: result.browser.name || 'Unknown',
      browserVersion: result.browser.version || 'Unknown',
      engineName: result.engine.name || 'Unknown',
      engineVersion: result.engine.version || 'Unknown',
      isMobile,
      isTablet,
      isDesktop,
    };
  }

  private static getClient(result: UAParser.IResult): 'web' | 'android' | 'ios' {
    const osName = result.os.name?.toLowerCase() || '';

    if (osName.includes('android')) {
      return 'android';
    }

    if (osName.includes('ios') || osName.includes('iphone') || osName.includes('ipad')) {
      return 'ios';
    }

    return 'web';
  }

  private static getDeviceType(result: UAParser.IResult): string {
    const { device } = result;

    if (device.vendor && device.model) {
      return `${device.vendor} ${device.model}`;
    }

    if (device.model) {
      return device.model;
    }

    if (device.vendor) {
      return device.vendor;
    }

    switch (result.device.type) {
      case 'mobile':
        return 'Mobile Device';
      case 'tablet':
        return 'Tablet';
      case 'smarttv':
        return 'Smart TV';
      case 'wearable':
        return 'Wearable Device';
      case 'console':
        return 'Gaming Console';
      default:
        return 'Desktop Computer';
    }
  }

  private static getScreenSize(): string {
    if (typeof window === 'undefined') {
      return 'Unknown';
    }

    const { width, height } = window.screen;
    const { devicePixelRatio = 1 } = window;

    return `${width}x${height} (${devicePixelRatio}x)`;
  }
}
